module.exports = __webpack_public_path__ + "static/img/name2.f461b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name2.png
// module id = tX3l
// module chunks = 1